import AdPerformanceSnapshot from "../../pages/admin/AdPerformanceSnapshot";
import Login from "../../pages/admin/auth/Login";
import Community from "../../pages/admin/community";
import AdminContent from "../../pages/admin/content";
import Dashboard from "../../pages/admin/dashboard";
import Events from "../../pages/admin/events";
import BootcampDetail from "../../pages/admin/events/BootcampDetail";
import CreateNuterra from "../../pages/admin/events/nuterra-wellness/CreateNuterra";
import EditNuterraDetails from "../../pages/admin/events/nuterra-wellness/EditNuterraDetails";
import NuterraDetails from "../../pages/admin/events/nuterra-wellness/NuterraDetails";
import WebinarDetail from "../../pages/admin/events/webinar/WebinarDetail";
import WorkShopDetails from "../../pages/admin/events/workshop/WorkShopDetails";
import Inbox from "../../pages/admin/Inbox";
import InviteProject from "../../pages/admin/InviteProject";
import Messaging from "../../pages/admin/Messaging";
import NewUserSignup from "../../pages/admin/NewUserSignup";
import Payment from "../../pages/admin/Payment";
// import InviteFreelancer from "../../pages/admin/InviteFreelancer";
import JobProjects from "../../pages/admin/project";
import Report from "../../pages/admin/Report";
import ReportDetails from "../../pages/admin/Report/ReportDetails";
import Services from "../../pages/admin/services";
import Setting from "../../pages/admin/setting";
import AddServices from "../../pages/admin/services/AddServices";
import Users from "../../pages/admin/users";
import AddWebinar from "../../pages/common/webinar/AddWebinar";
import UpdateWebinar from "../../pages/common/webinar/UpdateWebinar";
import AddWorkshpoDetails from "../../pages/common/workshop";
import UpdateAdminWorkshop from "../../pages/common/workshop/UpdateAdminWorkshop";
import SupportTicket from "../../pages/admin/support-ticket";

export const adminPaths = {
  Login: "/admin/login",
  Users: "/admin/users",
  Events: "/admin/events",
  Services: '/admin/services',
  AddServices: '/admin/add-services',
  BootcampDetail: "/admin/bootcamp-detail",
  UpdateWebinar: "/admin/update-webinar",
  AddWebinar: "/admin/add-webinar",
  WebinarDetail: "/admin/webinar-detail",
  AddWorkshop: "/admin/add-workshop",
  WorkShopDetails: "/admin/workShopDetails",
  UpdateWorkshopData: "/admin/update-workshop",
  AdminContent: "/admin/content",
  CreateNuterra: "/admin/create-nuterra-wellness",
  NuterraDetails: "/admin/nuterra-details",
  EditNuterraDetails: "/admin/edit-nuterra-details",
  JobProject: "/admin/project",
  // Inbox: "/admin/inbox",
  InviteProject: "/admin/invite-project",
  Dashboard: "/admin/admin-dashboard",
  Community: "/admin/community",
  Report: "/admin/report",
  ReportDetails: "/admin/report-details",
  Messaging: "/admin/messaging",
  Payment: "/admin/payment",
  SupportTicket: "/admin/support-ticket",
  Setting: "/admin/setting",
  AdPerformanceSnapshot: "/admin/Ad-performance-snapshot",
  NewUserSignup: "/admin/new-user-signup",
};

export const AllAdminRoutes = [
  {
    name: "Login",
    path: adminPaths.Login,
    element: <Login />,
    isPrivate: false,
  },
  {
    name: "Users",
    path: adminPaths.Users,
    element: <Users />,
    isPrivate: false,
  },
  {
    name: "Events",
    path: adminPaths.Events,
    element: <Events />,
    isPrivate: false,
  },
  {
    name: "Services",
    path: adminPaths.Services,
    element: <Services />,
    isPrivate: false,
  },
  {
    name: "Add Services",
    path: adminPaths.AddServices,
    element: <AddServices />,
    isPrivate: false,
  },
  {
    name: "Job Project",
    path: adminPaths.JobProject,
    element: <JobProjects />,
    isPrivate: false,
  },
  {
    name: "BootcampDetail",
    path: adminPaths.BootcampDetail,
    element: <BootcampDetail />,
    isPrivate: false,
  },
  {
    name: "AddWebinar",
    path: adminPaths.AddWebinar,
    element: <AddWebinar />,
    isPrivate: false,
  },
  {
    name: "Update Work shop Data",
    path: adminPaths.UpdateWorkshopData,
    element: <UpdateAdminWorkshop />,
    isPrivate: false,
  },
  {
    name: "UpdateWebinar",
    path: adminPaths.UpdateWebinar,
    element: <UpdateWebinar />,
    isPrivate: false,
  },
  {
    name: "WebinarDetail",
    path: adminPaths.WebinarDetail,
    element: <WebinarDetail />,
    isPrivate: false,
  },
  {
    name: "Add Workshop Details",
    path: adminPaths.AddWorkshop,
    element: <AddWorkshpoDetails />,
    isPrivate: false,
  },
  {
    name: "Work Shop Details",
    path: adminPaths.WorkShopDetails,
    element: <WorkShopDetails />,
    isPrivate: false,
  },
  {
    name: "Admin Content",
    path: adminPaths.AdminContent,
    element: <AdminContent />,
    isPrivate: false,
  },
  {
    name: "CreateNuterra",
    path: adminPaths.CreateNuterra,
    element: <CreateNuterra />,
    isPrivate: false,
  },
  {
    name: "NuterraDetails",
    path: adminPaths.NuterraDetails,
    element: <NuterraDetails />,
    isPrivate: false,
  },
  {
    name: "EditNuterraDetails",
    path: adminPaths.EditNuterraDetails,
    element: <EditNuterraDetails />,
    isPrivate: false,
  },
  {
    name: "InviteProject",
    path: adminPaths.InviteProject,
    element: <InviteProject />,
    isPrivate: false,
  },
  {
    name: "Inbox",
    path: adminPaths.Inbox,
    element: <Inbox />,
    isPrivate: false,
  },

  // Govind
  {
    name: "Dashboard",
    path: adminPaths.Dashboard,
    element: <Dashboard />,
    isPrivate: false,
  },
  // Govind
  {
    name: "Community",
    path: adminPaths.Community,
    element: <Community />,
    isPrivate: false,
  },

  // Govind
  // Govind
  {
    name: "Report",
    path: adminPaths.Report,
    element: <Report />,
    isPrivate: false,
  },

  // Govind

  // Govind
  {
    name: "Report Detals",
    path: adminPaths.ReportDetails,
    element: <ReportDetails />,
    isPrivate: false,
  },

  // Govind
  // Govind
  {
    name: "Messaging",
    path: adminPaths.Messaging,
    element: <Messaging />,
    isPrivate: false,
  },

  {
    name: "Support Ticket",
    path: adminPaths.SupportTicket,
    element: <SupportTicket />,
    isPrivate: false,
  },

  // Govind
  // Govind
  {
    name: "Payment",
    path: adminPaths.Payment,
    element: <Payment />,
    isPrivate: false,
  },

  // Govind
  // Govind
  {
    name: "Setting",
    path: adminPaths.Setting,
    element: <Setting />,
    isPrivate: false,
  },

  // Govind
  // Govind
  {
    name: "AdPerformanceSnapshot",
    path: adminPaths.AdPerformanceSnapshot,
    element: <AdPerformanceSnapshot />,
    isPrivate: false,
  },

  // Govind
  // Govind
  {
    name: "NewUserSignup",
    path: adminPaths.NewUserSignup,
    element: <NewUserSignup />,
    isPrivate: false,
  },

  // Govind
];
